
export const NavigationItems = [
  { value: "features" },
  { value: "benefits" },
  { value: "pricing" },
  { value: "testimonials" },
  { value: "faq" },
];

export const TestimonialsData = [{
  testimonial: "“WiseMate has transformed the way our team accesses data. What used to take hours of searching through files now takes seconds. Our productivity has soared, and we’re able to make decisions faster than ever.“",
  author: "Sarah M., Operations Manager at XYZ Corp"
},
{
  testimonial: "“WiseMate has become an essential tool for our marketing team. We no longer have to wait for reports from other departments; the chatbot provides instant insights into campaign performance and customer data, which has helped us optimize our strategy in real-time.“",
  author: "Sarah M., Operations Manager at XYZ Corp"
},
{
  testimonial: "“As the head of IT, data security is my top priority.With WiseMate, not only is our internal data more accessible, but it's also more secure. The encryption and access controls give us peace of mind while still empowering our teams.“",
  author: "James P., IT Director at ABC Inc."
},
{
  testimonial: "“Onboarding new employees used to be time- consuming, with everyone asking the same questions.Now, WiseMate handles all those common queries, from company policies to benefits, making the onboarding process smooth and freeing up HR for more strategic tasks.“",
  author: "Sarah M., Operations Manager at XYZ Corp"
}
]


